import { Box, Button, Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

type SearchFileProps = {
  sharingFile: File;
  setSharingFile: Dispatch<SetStateAction<File>>;
};

function SearchFile(props: SearchFileProps) {
  const { t } = useTranslation('pmo');

  const { sharingFile, setSharingFile } = props;

  return (
    <Box display="flex" alignItems="center">
      <div style={{ display: 'flex', width: '700px' }}>
        <input
          style={{
            width: '100%',
            marginTop: '0px',
            marginBottom: '0px',
            marginRight: '1rem',
            borderRadius: '8px',
            height: '38px',
          }}
          disabled
          value={sharingFile ? sharingFile.name : '  --- '}
        />
        <Button
          variant="contained"
          component="label"
          sx={{
            minWidth: '40%',
            height: '35px',
            borderRadius: '8px',
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
            }}
          >
            {t('choose.file')}
          </Typography>
          <input
            type="file"
            onChange={(e) => {
              if (e.target.files) {
                setSharingFile(e.target.files[0]);
              }
            }}
            hidden
            multiple={false}
          />
        </Button>
      </div>
    </Box>
  );
}

export default SearchFile;
